import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DocketService} from './docket.service';
import {IMyDateModel} from 'mydatepicker';
import {ElementRef, ViewChild} from '@angular/core';
import {Inject} from '@angular/core';
import {AuthentificationService} from './authentification.service';
import {FileDownloadService} from './file-download.service';
import {AppComponent} from './app.component';

import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';

import * as jsPDF from 'jspdf';
//import * as jpt from 'jspdf-autotable';
/*declare var jsPDF: any; // Important */
//declare let jsPDF;

@Component({
    selector: 'issue-stock',
    styleUrls: ['./styles/docket.component.css'],
    templateUrl: './templates/docket.component.html',
    providers: [DocketService, AuthentificationService, SortTable, FileDownloadService]
})



export class Docket {

    @ViewChild('toexport') el: ElementRef;
    remark: string = "";
    docket_operation: string;
    docket_details_list: any;
    id_selected_docket: number;
    operation: string = '';
    docket_name: string = "";
    date = "";
    total_price: string = '0';
    docket_infos: string = "";
    disabled_modify_bt = true;
    operation_bt: string = "Modifier";
    operation_bt_2: string = "Imprimer";
    doc: string = "BORDEREAU";
    sortedData: any = [];
    current_docket: any;
    pdf_disabled: boolean = true;
    session_mode: string = "DOCKET ABSTRACT";
    disabled_remark: boolean = true;
    /*docket_list: Array<any> = [
        {name: 'Bordereau 1', operation: 'ENTREE', date: "11-Juil-2017"},
        {name: 'Bordereau 2', operation: 'SORTIE', date: "11-Juil-2017"},
        {name: 'Bordereau 3', operation: 'SORTIE', date: "11-Juil-2017"},
        {name: 'Bordereau 4', operation: 'ENTREE', date: "11-Juil-2017"},
        {name: 'Bordereau 5', operation: 'ENTREE', date: "11-Juil-2017"},
        {name: 'Bordereau 6', operation: 'SORTIE', date: "11-Juil-2017"},
        {name: 'Bordereau 7', operation: 'ENTREE', date: "11-Juil-2017"},

    ];*/

    docket_list: any;

    operation_list: Array<any> = [{name: 'Entrée', operation: 'IN'}, {name: 'Sortie', operation: 'OUT'}, {name: 'Toute', operation: ''}];

    public list: string[];
    number_reference: any;
    docket_date: any;

    constructor(private app_component: AppComponent, private docket_service: DocketService, private authentification_service: AuthentificationService, private router: Router, private sort_table: SortTable, private file_download: FileDownloadService) {
        this.CheckUSerSession();
        this.app_component.valTest = 'docket-history';
        this.app_component.GetParent();
    }

    CheckUSerSession(): void {

        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }


    GetDocketDetails(docket: any): void {

        this.current_docket = docket;
        this.id_selected_docket = docket.id_docket;
        this.docket_date = docket.timestamp;
        this.docket_infos = ' ( ' + docket.reference_code + ' - ' + docket.docket_name + ' / ' + docket.timestamp + ' / ' + docket.operation + ' )';
        this.docket_name = docket.docket_name;
        this.number_reference = docket.id_docket;
        this.docket_service.GetDocketDetails(docket.id_docket).then(result => {
            this.docket_operation = result['operation'];
            this.docket_details_list = result['list'];
            this.remark = result['remark'];
            this.getTotalPrice(); this.Init();

            if (result['total_price'] !== []) {
                this.pdf_disabled = false
            } else {this.pdf_disabled = true}
        });
    }


    total: number = 0;
    getTotalPrice() {
        let total = 0;
        for (var i = 0; i < this.docket_details_list.length; i++) {
            if (this.docket_details_list[i].remark != 'DELETE') {
                total += (this.docket_details_list[i].new_quantity * this.docket_details_list[i].unit_price);
            }
        }
        this.total = total;
    }


    Init(): void {
        this.disabled_modify_bt = false;
        this.operation_bt = 'Modifier';
        this.operation_bt_2 = 'Imprimer';
    }

    Search(operation: any, value: any): void {
        switch (operation) {
            case 'name':
                this.docket_name = value;
                break;
            case 'op':
                this.docket_name = value;
                break;
            case 'date':
                this.date = value;
                break;
            default:

                break;
        }
        console.log(this.date);
        this.docket_service.SearchDocket(this.docket_name, this.operation, this.date).then(list => {this.docket_list = list; this.sortedData = list; this.sort_table.SetDataArray(list, [{value: "reference_code", type: ""}, {value: "docket_name", type: ""}, {value: "operation", type: ""}, {value: "timestamp", type: ""}]);});
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
        // recupérer  data
    }

    OperationBt(): void {
        if (this.operation_bt === "Modifier") {
            this.ModifyDocket();
        } else if (this.operation_bt === "Valider") {
            this.ValidModification();
        }
    }

    DeleteArticle(article_index: string): void {
        //console.log(article_index);
        this.docket_service.DeleteArticle(article_index, this.total_price).then(result => {this.docket_details_list = result['list']; this.total_price = result['total_price']; this.getTotalPrice();/*if (result['list'].length === 0) {this.disabled_modify_bt = true;} else {this.disabled_modify_bt = false;}*/});
    }

    OperationBt2(): void {
        if (this.operation_bt_2 === "Imprimer") {
            this.Print();
        } else if (this.operation_bt_2 === "Annuler") {
            this.CancelModificationDocket();
        }
    }

    ValidModification(): void {
        this.docket_service.ValidateMofidication(this.remark).then(result => {
            this.disabled_remark = true;
            this.remark = "";
            this.docket_details_list = result['docket_details_list']; this.getTotalPrice(); this.docket_list = result['docket_list']; if (result['docket_details_list'] === []) {this.disabled_modify_bt = true;} else {this.disabled_modify_bt = false;}; this.operation_bt = 'Modifier';
            this.operation_bt_2 = 'Imprimer';

            this.sortedData = result['docket_list'];
            this.sort_table.SetDataArray(result['docket_list'], [{value: "reference_code", type: ""}, {value: "docket_name", type: ""}, {value: "operation", type: ""}, {value: "timestamp", type: ""}]);
        });
    }

    Print(): void {
        //this.createPdf();
        this.file_download.DocketPdf(this.current_docket);
    }

    SessionMod(list: any): void {
        this.session_mode = "DOCKET ABSTRACT";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
        //console.log(this.session_mode);
    }

    ModifyDocket(): void {
        this.docket_service.ModifyDocket().then(result => {this.disabled_remark = false; this.docket_details_list = result['list']; this.operation_bt = "Valider"; this.operation_bt_2 = "Annuler"; this.SessionMod(result['list']);/*this.disabled_modify_bt = true;*/});
    }

    CancelModificationDocket(): void {
        this.docket_service.CancelModification().then(result => {this.remark = result['remark']; this.disabled_remark = true; this.docket_details_list = result['list']; this.operation_bt = "Modifier"; this.operation_bt_2 = "Imprimer"; this.disabled_modify_bt = false; this.total_price = result['total_price'];});
    }

    onDateChanged(event: IMyDateModel) {
        // event properties are: event.date, event.jsdate, event.formatted and event.epoc
        // console.log('onDateChanged(): ', event.date, ' - jsdate: ', new Date(event.jsdate).toLocaleDateString("en-US"), ' - formatted: ', event.formatted, ' - epoc timestamp: ', event.epoc);
        if (event.jsdate === null) {
            this.date = "";
        } else {
            this.date = event.jsdate.toLocaleDateString("en-US");
        }
        this.Search('date', this.date);
    }

    FormatPrice(price: any): string {
        return Math.round(price).toLocaleString() + ' Ar';
    }

    createPdf(): void {
        let pdf = new jsPDF('l', 'pt', 'a4');
        let options = {
            pagesplit: true
        };
        pdf.addHTML(this.el.nativeElement, 0, 0, options, () => {
            pdf.save(this.doc + ".pdf");
        });
    }

    EditAndValidateModification(docket: any): void {
        //console.log(this.src_bt);

        //if (this.src_bt === "../../img/ico_modif.png") {prod.status === "RECEIPTION"
        if (docket.status === "RECEPTION") {
            //console.log(prod.id_article);
            this.EditDocketSession(docket);
        } else if (docket.status === 'MODIFICATION') {
            this.ValidateEditDocketSession(docket);
        }
    }

    EditDocketSession(docket: any): void {
        this.docket_service.EditDocketSession(docket.article_index).then(result => {this.docket_details_list = result['list']; this.SessionMod(result['list'])});
        //this.stocks_service.EditArticleSessionReceipt(prod.index).then(result => {this.prod_session_list = result['list']; this.SessionMod(result['list'])});
    }

    ValidateEditDocketSession(docket: any): void {
        if (isNaN(docket.quantity)) {
            docket.quantity = "Valeur invalide";
            setTimeout(() => {this.LoadSessionDocket()}, 3500);
        }
        else {
            this.docket_service.ValidateEditDocketSession(docket).then(result => {this.docket_details_list = result['list']; this.SessionMod(result['list'])});
            // this.stocks_service.ValidateEditArticleSessionReceipt(prod).then(result => {this.prod_session_list = result['list']; this.SessionMod(result['list'])});
        }
    }

    LoadSessionDocket(): void {
        //this.stocks_service.LoadSessionDocket().then(result => {this.prod_session_list = result['list']; if (result['list'].length !== 0) {this.validate_docket_bt = false} });
    }

    selected_tr: number = -1;
    Selected(value: number): void {
        this.selected_tr = value;
    }

    Color(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }
    
       
    ColorIndex(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }

        return styles;
    }

    ngOnInit(): void {
        this.Search('', '');
    }

}



// WEBPACK FOOTER //
// ./src/app/docket.component.ts